import Notification from '@/components/Notification';
import styled from 'styled-components';

export const NotificationBar = styled(Notification)`
  background-color: ${({ theme }) => theme.color.spaceGray};
`;
